import { useState } from "react";
import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { Adjunto, ListadoCobros, ListadoVentas } from "@/lib/api";
import { filtrosCobrosIniciales, nombreUnidades, queryCobros, TODOS, type FiltrosCobros } from "@/lib/ventas";

/** Lógica de Cobranzas (sin JSX): listado plano de cobros con filtros. Sólo lectura para los cuatro roles; los cobros se cargan en la ficha de la venta. */
export function useCobrosTab() {
  const { fid } = useContextoApp();
  const [filtros, setFiltros] = useState<FiltrosCobros>(filtrosCobrosIniciales);
  const listado = useApiResource<ListadoCobros>(`/api/fideicomisos/${fid}/cobros${queryCobros(filtros)}`);
  const ventas = useApiResource<ListadoVentas>(`/api/fideicomisos/${fid}/ventas`);

  return {
    items: listado.data?.items ?? [],
    totales: listado.data?.totales ?? null,
    cargando: listado.loading && !listado.data,
    errorCarga: listado.data ? null : (listado.error?.message ?? null),
    reintentar: listado.recargar,
    filtros,
    cambiarFiltro: <K extends keyof FiltrosCobros>(campo: K, valor: FiltrosCobros[K]) => setFiltros((f) => ({ ...f, [campo]: valor })),
    limpiarFiltros: () => setFiltros(filtrosCobrosIniciales()),
    hayFiltros: queryCobros(filtros) !== "",
    opcionesVenta: [
      { valor: TODOS, etiqueta: "Todas las ventas" },
      ...(ventas.data?.items ?? []).map((v) => ({ valor: String(v.id), etiqueta: `Venta ${v.numero} · ${nombreUnidades(v.unidades)}` })),
    ],
    rutaDescarga: (a: Adjunto) => `/api/fideicomisos/${fid}/adjuntos/${a.id}/descarga`,
  };
}
